import { InformationIcon } from 'assets/images/shopping';
import PaymentDetailsModal from 'components/PaymentDetailsModal/PaymentDetailsModal';
import { useModal } from 'hooks/useModal';
import { INudosTransfDetailsData } from 'types/paymentDetails';

import './ViewPaymentDataButton.scss';

interface IViewPaymentDataButton {
  paymentData?: INudosTransfDetailsData;
}

export const ViewPaymentDataButton = ({ paymentData }: IViewPaymentDataButton) => {
  const { isOpen, open, close } = useModal();
  return (
    <>
      {isOpen && <PaymentDetailsModal paymentDetailsModalData={paymentData} closeModalCallback={close} />}
      <button className="viewPaymentDataButton" onClick={open}>
        <InformationIcon className="informationIcon" />
        Ver datos de pago
      </button>
    </>
  );
};
